var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"giftshop-login-button uk-button uk-button-primary",on:{"click":_vm.handleClick}},[(_vm.isSignedIn)?[_vm._v(_vm._s(_vm.signoutText))]:[_vm._v(_vm._s(_vm.loginText))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }